import { Component, Input, OnInit } from '@angular/core';
import { Correspondence } from '@shared/models/correspondence';

@Component({
    selector: 'app-correspondence',
    templateUrl: './correspondence.component.html',
    styleUrls: ['./correspondence.component.scss'],
    standalone: false
})
export class CorrespondenceComponent implements OnInit {
  @Input() correspondenceList: Array<Array<Correspondence>>;
  @Input() downLoadDocumentUrl: string;

  constructor() { }

  ngOnInit(): void {
  }

  clickDownload(itemId: string): void {
    window.open(this.downLoadDocumentUrl + itemId);
  }

}
